var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { TooltipContext } from '../../context/tooltip';
import { TooltipType } from '../../types/tooltips';
export default function IconButton(_a) {
    var icon = _a.icon, onClick = _a.onClick, disabled = _a.disabled, alternative = _a.alternative, highlighted = _a.highlighted, warning = _a.warning, invisible = _a.invisible, undisplayed = _a.undisplayed, link = _a.link, linkState = _a.linkState, className = _a.className, tooltip = _a.tooltip;
    var setTooltipProps = useContext(TooltipContext).setTooltipProps;
    function showTooltip(event) {
        if (!tooltip)
            return;
        var rect = event.currentTarget.getBoundingClientRect();
        setTooltipProps({
            common: {
                rect: rect,
                position: tooltip.position,
                mobilePosition: tooltip.mobilePosition,
            },
            custom: {
                type: TooltipType.SIMPLE,
                message: tooltip.message,
            },
        });
    }
    return (_jsx(Container, { alternative: alternative, className: className, highlighted: highlighted, invisible: invisible, onClick: disabled ? undefined : onClick, onMouseEnter: tooltip ? showTooltip : undefined, onMouseLeave: tooltip ? function () { return setTooltipProps(undefined); } : undefined, unclickable: disabled, undisplayed: undisplayed, warning: warning, children: link && !disabled ? (_jsx(Link, { state: linkState, to: link, children: _jsx("img", { alt: "", src: icon }) })) : (_jsx("div", { children: _jsx("img", { alt: "", src: icon }) })) }));
}
var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border: ", ";\n  border-radius: 8px;\n  cursor: ", ";\n  display: ", ";\n  filter: ", ";\n  flex-shrink: 0;\n  height: 48px;\n  height: 48px;\n  opacity: ", ";\n  padding: 2px;\n  pointer-events: ", ";\n  position: relative;\n  width: 48px;\n\n  & > a,\n  & > div {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n    justify-content: center;\n    opacity: ", ";\n    text-decoration: none;\n    text-transform: uppercase;\n    width: 100%;\n\n    & > img {\n      height: 100%;\n      width: 100%;\n    }\n  }\n\n  &:hover {\n    opacity: ", ";\n\n    & > div:nth-child(2) {\n      opacity: 1 !important;\n    }\n  }\n"], ["\n  background: ", ";\n  border: ", ";\n  border-radius: 8px;\n  cursor: ", ";\n  display: ", ";\n  filter: ", ";\n  flex-shrink: 0;\n  height: 48px;\n  height: 48px;\n  opacity: ", ";\n  padding: 2px;\n  pointer-events: ", ";\n  position: relative;\n  width: 48px;\n\n  & > a,\n  & > div {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n    justify-content: center;\n    opacity: ", ";\n    text-decoration: none;\n    text-transform: uppercase;\n    width: 100%;\n\n    & > img {\n      height: 100%;\n      width: 100%;\n    }\n  }\n\n  &:hover {\n    opacity: ", ";\n\n    & > div:nth-child(2) {\n      opacity: 1 !important;\n    }\n  }\n"])), function (_a) {
    var alternative = _a.alternative, highlighted = _a.highlighted, warning = _a.warning, theme = _a.theme;
    if (highlighted) {
        return theme.palette.button.highlighted;
    }
    if (alternative) {
        return theme.palette.button.alternative;
    }
    if (warning) {
        return theme.palette.button.warning;
    }
    return theme.palette.button.default;
}, function (_a) {
    var alternative = _a.alternative, highlighted = _a.highlighted, warning = _a.warning, theme = _a.theme;
    if (highlighted) {
        return "solid 1px ".concat(theme.palette.button.highlighted);
    }
    if (alternative) {
        return "solid 1px ".concat(theme.palette.button.alternative);
    }
    if (warning) {
        return 'solid 1px #ff6f6f';
    }
    return "solid 1px ".concat(theme.palette.purple);
}, function (_a) {
    var unclickable = _a.unclickable;
    return (unclickable ? 'auto' : 'pointer');
}, function (_a) {
    var undisplayed = _a.undisplayed;
    return (undisplayed ? 'none !important' : 'flex');
}, function (_a) {
    var unclickable = _a.unclickable;
    return (unclickable ? 'grayscale(100%)' : 'none');
}, function (_a) {
    var unclickable = _a.unclickable, invisible = _a.invisible;
    if (invisible)
        return '0';
    return unclickable ? '0.5' : '1';
}, function (_a) {
    var invisible = _a.invisible;
    return (invisible ? 'none' : 'auto');
}, function (_a) {
    var unclickable = _a.unclickable;
    return (unclickable ? '0.5' : '1');
}, function (_a) {
    var unclickable = _a.unclickable, invisible = _a.invisible;
    if (invisible)
        return '0';
    return unclickable ? '0.5' : '0.7';
});
var templateObject_1;
